import { render, staticRenderFns } from "./Func31Listagem.vue?vue&type=template&id=2d1cb6f8&scoped=true"
import script from "./Func31Listagem.vue?vue&type=script&lang=js"
export * from "./Func31Listagem.vue?vue&type=script&lang=js"
import style0 from "./Func31Listagem.vue?vue&type=style&index=0&id=2d1cb6f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1cb6f8",
  null
  
)

export default component.exports